import { useCallback, useState } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { showNotification } from 'app/providers/NotificationsProvider';
import { useSendPriceRaiseNotificationMutation } from 'entities/Contract';

interface HookApi {
  send: () => void;
  isOpened: boolean;
  isLoading: boolean;
  open: (contractItemPriceRaiseId: string) => void;
  close: () => void;
}

export const useSendPriceRaiseNotification = (): HookApi => {
  const [contractItemPriceRaiseId, setContractItemPriceRaiseId] = useState<string>();

  const { t } = useAppTranslation('common');

  const [sendNotification, { isLoading }] = useSendPriceRaiseNotificationMutation();

  const open = useCallback((id: string): void => {
    setContractItemPriceRaiseId(id);
  }, []);

  const close = useCallback((): void => {
    setContractItemPriceRaiseId(undefined);
  }, []);

  const send = useCallback(async (): Promise<void> => {
    if (!contractItemPriceRaiseId) {
      return;
    }

    try {
      await sendNotification(contractItemPriceRaiseId).unwrap();

      showNotification('info', t('Success'), t('Price raise notification has been sent'));
    } catch (error: CustomAny) {
      console.log(error);
      showNotification('error', t('Error'), t('Error when sending price raise notification'));
    } finally {
      close();
    }
  }, [close, contractItemPriceRaiseId, sendNotification, t]);

  return {
    send,
    open,
    close,
    isOpened: Boolean(contractItemPriceRaiseId),
    isLoading,
  };
};
